/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_DeclineInputs */

const en_btn_decline = /** @type {(inputs: Btn_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Btn_DeclineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_decline = /** @type {((inputs?: Btn_DeclineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_DeclineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_decline(inputs)
});